<template>
  <b-row id="singles-block" class="section-invert">
    <b-col md="12" lg="6" class="content my-auto">
      <!-- <h3>{{ $t('best-legal-services') }}</h3> -->
      <div class="subtitle">
        <div class="subtitle-list mt-5">
           <b-row v-for="item in items" :key="item">
             <b-col cols="1">
                <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
              </b-col>
              <b-col cols="10" offset-sm="1">
                <span>
                  {{ item }}
                </span>
              </b-col>
           </b-row>
           <b-row class="mt-5">
              <base-button white outline @click="$helpers.goToSection('contact-form')">{{ $t('openlegal.more-info') }}</base-button>
            </b-row>
        </div>
      </div>
    </b-col>
    <b-col md="12" lg="6">
      <div class="col-bg ml-lg-auto">
      </div>
    </b-col>
  </b-row>
</template>

<script>

let messages = {
  es: {
    'best-legal-services': 'El mejor servicio legal para empresas y particulares',
    'item1': 'Resuelve cualquier duda, sin esperas ni desplazamientos.',
    'item2': 'Revisamos y redactamos tus contratos, documentos...',
    'item3': 'Te ayudamos a gestionar tus reclamaciones.',
    'item4': 'Recurrimos tus multas de tráfico',
    'item5': 'Cancelamos tus contratos de servicios y seguros.',
    'item6': 'Precios bonificados para asistencia en juicios.',
    'available-soon': 'Disponible próximamente'
  },
  en: {
    'best-legal-services': 'The best legal services for companies and individuals',
    'item1': 'Resolves any doubt, without waiting or moving.',
    'item2': 'We review and draft your contracts, documents...',
    'item3': 'We help you manage your claims.',
    'item4': 'We appeal your traffic fines',
    'item5': 'We cancel your service and insurance contracts.',
    'item6': 'Reduced prices for court assistance.',
    'available-soon': 'Available soon'
  }
}

messages.mx = messages.es

export default {
  i18n: {
    messages
  },
  data () {
    return {
      items: [
        this.$t('item1'), this.$t('item2'), this.$t('item3'), this.$t('item4'), this.$t('item5'), this.$t('item6')
      ]
    }
  }
}
</script>

<style lang="scss">
  #singles-block {
    .col-bg {
      background-blend-mode: overlay;
      background-image: url('/static-appopensalud/img/bgs/openlegal/Imagen1.png'), linear-gradient(to bottom, $body-bg, transparent), linear-gradient(to top, transparent, $body-bg);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/OpenlegalForIndividuals.vue